@if (!loading) {
  <mat-expansion-panel
    [hideToggle]="servicePackageIsDisabled"
    [disabled]="servicePackageIsDisabled"
    #servicePackagePanel
  (afterExpand)="
    sendContentModulesData(
      true,
      'customerPortal.customer-portal.vehicle.servicepackage'
    )
  "
  (afterCollapse)="
    sendContentModulesData(
      false,
      'customerPortal.customer-portal.vehicle.servicepackage'
    )
  "
    >
    <mat-expansion-panel-header
      class="p-0 md:px-6"
      [collapsedHeight]="'auto'"
      [expandedHeight]="'auto'"
      >
      <mat-panel-title>
        <div class="mt-1 mr-1">
          <mat-icon
            class="text-mat-ef-revolution-primary-500"
            [ngClass]="servicePackagePanel.expanded ? 'blue-icon' : ''"
            svgIcon="build"
          ></mat-icon>
        </div>
        @if (servicePackage) {
          <div class="vehicle-expansion-panel-text">
            <div
              class="w-full pt-1 overflow-hidden whitespace-nowrap text-ellipsis"
              >
              <div class="flex text-sm sm:text-base font-bold">
                <span
                  ><T
                  str="Service package"
                  key="customerPortal.customer-portal.vehicle.servicepackage"
                  tags="customer-portal, 3.1"
                  ></T
                ></span>
                @if (showWarning) {
                  <span
                    class="leasing-title-warning"
                    [ngClass]="styleLeasingWarningIcon(servicePackages)"
                    >
                    <mat-icon svgIcon="error"></mat-icon>
                  </span>
                }
              </div>
            </div>
            @if (!servicePackage?.expired && servicePackage?.purchased) {
              <mat-progress-bar
                [ngClass]="styleServicePackageProgressBar(servicePackage)"
                class="h-0.5"
                mode="determinate"
                value="{{ percentageTillExpires.toString() }}"
                dir="rtl"
                >
              </mat-progress-bar>
            }
            @if (servicePackage?.expired && servicePackage?.purchased) {
              <div
                class="text-sm font-efSans-primary py-1 px-0"
                >
                <T
                str="The service package expired on {endDate}."
                key="customerPortal.customer-portal.vehicle.servicepackage.expired"
                tags="customer-portal, 3.1"
                [vars]="{ endDate: servicePackage?.endDate | date: dateFormat }"
              ></T>
            </div>
          }
          @if (!servicePackage?.expired && servicePackage?.purchased) {
            <div
              class="text-sm font-efSans-primary py-1 px-0"
              >
              <T
              str="The service package expires in {days} days."
              key="customerPortal.customer-portal.vehicle.servicepackage.expiration"
              tags="customer-portal, 3.1"
              [vars]="{ days: tillExpires }"
            ></T>
          </div>
        }
      </div>
    }
    @if (!servicePackage) {
      <div class="vehicle-expansion-panel-text">
        <div
          class="w-full pt-1 overflow-hidden whitespace-nowrap text-ellipsis"
          >
          <div class="flex text-sm sm:text-base font-bold">
            <span
              ><T
              str="Service package"
              key="customerPortal.customer-portal.vehicle.servicepackage"
              tags="customer-portal, 3.1"
              ></T
            ></span>
          </div>
        </div>
        <div class="text-sm font-efSanspy-1 px-0">
          <T
          str="No service pack"
          key="customerPortal.customer-portal.vehicle.servicepackage.none"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    </div>
  }
</mat-panel-title>
</mat-expansion-panel-header>
<mat-divider class="leasing-divider -mx-6 md:m-0"></mat-divider>
<div class="-mx-6 md:m-0 text-mat-ef-revolution-primary-500 font-normal">
  <!-- brand warranty link -->
  <div [ngClass]="{ 'ml-0 md:ml-11': hasLinks }">
    <customer-portal-app-brand-links
      [type]="'servicePackage'"
      [brand]="vehicle?.brand"
      (hasLinks)="hasLinksChanged($event)"
      >
    </customer-portal-app-brand-links>
  </div>
  <!-- Service packages -->
  @if (servicePackages?.length > 0) {
    <div
      class="ml-0 md:ml-11 mt-2.5 gap-1 flex flex-col"
      >
      @for (sp of purchasedServicePackages; track sp; let last = $last) {
        <div class="mt-1">
          <span class="text-sm font-efSans-primary">{{ sp?.description }}</span>
        </div>
        @if (!sp.expired && sp !== servicePackage) {
          <mat-progress-bar
            [ngClass]="styleLeasingProgressBar(sp)"
            class="h-0.5"
            mode="determinate"
            value="{{ tillExpiration(sp).percentage.toString() }}"
            dir="rtl"
            >
          </mat-progress-bar>
        }
        @if (!sp.expired) {
          <div class="text-sm font-efSans-primary py-1 px-0">
            <T
            str="Until"
            key="customerPortal.customer-portal.until"
            tags="customer-portal, 3.1"
          ></T>
          {{ sp.endDate | date: dateFormat }}
          <T
          str="The service package expires in {days} days."
          key="customerPortal.customer-portal.vehicle.servicepackage.expiration"
          tags="customer-portal, 3.1"
          [vars]="{ days: tillExpiration(sp).days }"
        ></T>
      </div>
    }
    @if (sp.expired) {
      @if (sp.expireReason === 'DATE') {
        <div
          class="text-sm font-efSans-primary py-1 px-0"
          >
          <T
          str="The warranty expired on {endDate}."
          key="customerPortal.customer-portal.vehicle.extendedwarranty.expired.time"
          tags="customer-portal, 3.1"
          [vars]="{ endDate: sp.endDate | date: dateFormat }"
        ></T>
      </div>
    }
    @if (sp.expireReason === 'MILEAGE') {
      <div
        class="text-sm font-efSans-primary py-1 px-0"
        >
        <T
        str="The warranty expired on {maxMileage} km."
        key="customerPortal.customer-portal.vehicle.extendedwarranty.expired.mileage"
        tags="customer-portal, 3.1"
        [vars]="{ maxMileage: sp.maxMileage }"
      ></T>
    </div>
  }
}
@if (!last) {
  <mat-divider class="my-2"></mat-divider>
}
}
@if (unpurchasedServicePackages?.length > 0) {
  @for (o of unpurchasedServicePackages; track o; let last = $last) {
    <div
      class="my-2.5 mx-0 p-2.5 bg-gray-100 rounded-md gap-1 flex flex-col"
      >
      <div class="flex flex-row justify-between items-center">
        <div class="flex flex-col md:flex-row gap-2.5 items-baseline">
          <span class="text-sm text-efSans font-semibold">
            <T
            str="Optional"
            key="customerPortal.customer-portal.vehicle.warranty.optional"
            tags="customer-portal, 3.1"
          ></T>
        </span>
        <span class="text-sm text-efSans">{{ o?.description }}</span>
      </div>
      <div
        class="min-w-fit text-sm font-efSans text-mat-ef-revolution-secondary-500 cursor-pointer bg-white px-4 py-1 rounded-2xl font-semibold inline-block overflow-hidden whitespace-nowrap"
              (click)="
                openWarrantyPackageContactPopup(
                  'offerRequest',
                  'servicePackage',
                  o
                )
              "
        >
        <T
        str="Inquire now"
        key="customerPortal.customer-portal.vehicle.warranty.requestNow"
        tags="customer-portal, 3.1"
      ></T>
    </div>
  </div>
</div>
}
}
</div>
}
</div>
</mat-expansion-panel>
}
